<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>结算管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getRecordList"></create>
      </div>
      <div class="page-actions">
        <el-select
          v-model="filter.leagueId"
          @change="getRecordList"
          placeholder="门派"
        >
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name && item.name.zh"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <el-table :data="labels">
        <el-table-column prop="leagueId" label="门派ID"> </el-table-column>
        <el-table-column prop="ranking" label="排名">
          <template slot-scope="scope">
            <span v-if="scope.row.ranking == 0">掌门</span>
            <span v-else-if="scope.row.ranking == 9999">普通弟子</span>
            <span v-else>{{ scope.row.ranking }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称号"> </el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Create from './components/Create';
import math from 'common/math';
export default {
  name: 'leagueMain',
  data() {
    return {
      filter: {
        leagueId: undefined
      },
      math
    };
  },
  components: {
    Create
  },
  computed: {
    ...mapState('leagueLabel', ['labels']),
    ...mapState('league', ['list'])
  },
  watch: {
    list: {
      handler(val) {
        if (val && val.length) {
          this.filter.leagueId = val[0].id;
          this.getRecordList();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('leagueLabel', ['getLabels', 'removeLabel']),
    ...mapActions('league', ['getList']),
    getRecordList(data = {}) {
      this.getLabels({ ...this.filter, ...data });
    },
    handleCurrentChange(pagination) {
      this.getRecordList(pagination);
    },
    remove(id) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.removeLabel({ id }).then(() => {
            this.$message.success('操作成功！');
            this.$emit('refresh');
          });
        }
      );
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
